import styled from "styled-components";

import Image from "../../images/image8.png";

export const Container = styled.section`
  padding: 50px 20px;
  display: flex;
  justify-content: center;
  background-image: url(${Image});
  background-repeat: no-repeat;
  background-size: cover;
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1,
  p {
    color: white;
  }

  h1 {
    font-family: "Noto Serif";
    font-size: 40px;
  }

  p {
    font-family: "Montserrat";
  }
`;

export const ContainerCard = styled.div`
  padding-top: 100px;

  @media (max-width: 768px) {
    padding-top: 20px;
  }
`;
